import { Chip } from "@mui/material";
import useSWR from "swr";

import { getAdminOrders, getCustomerOrders } from "../services/order.service";
import { SWRType } from "../types/global";
import { OrderFilters, OrderStatus } from "../types/order";

const useCrmOrders = (
  autoFetch = false,
  filters: OrderFilters = {},
  useCustomerEndpoint = false,
) => {
  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch
      ? [useCustomerEndpoint ? "crm-customer-orders" : "crm-admin-orders", filters]
      : null,
    ([, queryParams]) => {
      const fetchFn = useCustomerEndpoint ? getCustomerOrders : getAdminOrders;
      return fetchFn({
        ...queryParams,
        ...(Array.isArray(queryParams?.sort) && queryParams.sort.length > 0
          ? { sort: queryParams.sort.join(",") }
          : {}),
      });
    },
    {
      onErrorRetry: (fetchError) => {
        if (fetchError.status === 404) return;
      },
    },
  );

  const getStatusChip = (status?: OrderStatus) => {
    switch (status) {
      case "RECEIVED":
        return <Chip label="Received" color="info" size="small" />;
      case "CREATED":
        return <Chip label="Created" color="primary" size="small" />;
      case "REQUEST_MORE_INFO":
        return <Chip label="Request More Info" color="warning" size="small" />;
      case "UPDATED":
        return <Chip label="Updated" color="secondary" size="small" />;
      case "CANCELLED":
        return <Chip label="Cancelled" color="error" size="small" />;
      default:
        return <Chip label="Unknown" size="small" />;
    }
  };

  return {
    data,
    dataLoading,
    mutate,
    error,
    getStatusChip,
  };
};

export default useCrmOrders;
